import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Table from '../../../../../components/common/table/table';
import FieldTypes from '../../../../../enums/field-types';
import { FieldHistoryDataOwnershipTable } from '../../../../../interfaces/field-history';
import { useService } from '../../../../../services/services';
import css from './ownership.module.css';

export default function FieldHistoryDataOwnershipIndex() {
  const { t } = useTranslation();
  const tp = useCallback(
    (key: string) =>
      t(
        'pages.crop.field-history.history.section.data.ownership.fields.'.concat(
          key
        )
      ),
    [t]
  );
  const { fieldService } = useService();
  const { farmId, season, id } = useParams<{
    farmId: string;
    season: string;
    id: string;
  }>();

  const request = useCallback(
    (page: number, sort: string, desc: boolean, filter: any) =>
      fieldService.fieldHistorySectionDataOwnership(farmId, season, id),
    [fieldService, farmId, season, id]
  );

  return (
    <Table<FieldHistoryDataOwnershipTable>
      request={request}
      keyAccessor="id"
      paginate={false}
      columns={[
        {
          accessor: 'date',
          header: tp('date'),
          dataType: FieldTypes.DATE,
        },
        {
          accessor: 'season',
          header: tp('season'),
        },
        {
          accessor: 'lad_number',
          header: tp('lad_number'),
          className: css['strong'],
        },
        {
          accessor: 'name',
          header: tp('name'),
          className: css['strong'],
        },
        {
          accessor: 'area',
          header: tp('area'),
        },
        {
          accessor: 'block_number',
          header: tp('block_number'),
        },
        {
          accessor: 'foregrowth',
          header: tp('foregrowth'),
        },
        {
          accessor: 'product_type',
          header: tp('product_type'),
          dataType: FieldTypes.JSON_AGG,
        },
        {
          accessor: 'product',
          header: tp('product'),
          dataType: FieldTypes.JSON_AGG,
        },
        {
          accessor: 'interculture',
          header: tp('interculture'),
          dataType: FieldTypes.JSON_AGG,
        },
        {
          accessor: 'intercrop',
          header: tp('intercrop'),
          dataType: FieldTypes.JSON_AGG,
        },
        {
          accessor: 'ownership',
          header: tp('ownership'),
        },
      ]}
    />
  );
}
